import React, { Component } from 'react';
import styled, { css } from 'styled-components';
import ReactCountUp from 'react-countup';

import Container from 'partials/Container';
import GridElement from 'partials/GridElement';

import GreenLogo from 'icons/FooterLogo';

import Media from 'css/Media';


class Numbers extends Component {

    constructor(props) {
        super(props);
        this.state = {
            inSight: false, 
        };
        this.numbersRef = React.createRef();
    }

    componentDidMount() {
        this.setModuleObservable();
    }

    componentDidUpdate(prevProps) {
        if(prevProps.data !== this.props.data) {
            this.setModuleObservable();
        }
    }

    setModuleObservable() {
        this.io = new IntersectionObserver((el, observer) => {
            let element = el[0];

            if(element && element.isIntersecting) {
                this.setState({ inSight: true })
                observer.disconnect();
            }
        },
        {
            threshold: 0.6
        }
        );

        if(this.props.data) {
            this.io.observe(this.numbersRef.current)
        }
    }

    render() {
        const { inSight } = this.state;
        const { data } = this.props;
        
        return (
            <ModuleWrapper>
                <Container grid mobileBleed>
                    <GridElement
                        colStart={{default: 1, s: 3}}
                        colEnd={{default: 8, s: 22}}
                    >
                        <InnerGrid ref={this.numbersRef}>
                            {data.title &&
                            <GridElement
                                colStart={{default: 2, s: 3}}
                                colEnd={{default: 7, s: 18}}
                                rowStart={1}
                                rowEnd={1}
                            >
                                <h2>{data.title}</h2>
                            </GridElement>
                            }
                            { data.col_one_num && inSight &&
                                <StyledGridElement
                                    colStart={{default: 2, s: 3}}
                                    colEnd={{default: 5, s: 6}}
                                    rowStart={2}
                                    rowEnd={2}
                                    visible={inSight}
                                >
                                    <span><ReactCountUp start={0} end={parseInt(data.col_one_num)} duration={2.75} /></span>
                                    <p>{data.col_one_text}</p>
                                </StyledGridElement>
                            }
                            { data.col_two_num && inSight &&
                                <StyledGridElement
                                    colStart={{default: 6, s: 7}}
                                    colEnd={{default: 8, s: 10}}
                                    rowStart={2}
                                    rowEnd={2}
                                    visible={inSight}
                                >
                                    <span><ReactCountUp start={0} end={parseInt(data.col_two_num)} duration={2.75} /></span>
                                    <p>{data.col_two_text}</p>
                                </StyledGridElement>
                            }
                            { data.col_three_num && inSight &&
                                <StyledGridElement
                                    colStart={{default: 2, s: 11}}
                                    colEnd={{default: 5, s: 14}}
                                    rowStart={{default: 3, s: 2}}
                                    rowEnd={{default: 3, s: 2}}
                                    visible={inSight}
                                >
                                    <span><ReactCountUp start={0} end={parseInt(data.col_three_num)} duration={2.75} /></span>
                                    <p>{data.col_three_text}</p>
                                </StyledGridElement>
                            }
                            { data.col_four_num && inSight &&
                                <StyledGridElement
                                    colStart={{default: 6, s: 15}}
                                    colEnd={{default: 8, s: 18}}
                                    rowStart={{default: 3, s: 2}}
                                    rowEnd={{default: 3, s: 2}}
                                    visible={inSight}
                                >
                                    <span><ReactCountUp start={0} end={parseInt(data.col_four_num)} duration={2.75} /></span>
                                    <p>{data.col_four_text}</p>
                                </StyledGridElement>
                            }
                            <StyledLogo />
                        </InnerGrid>
                    </GridElement>
                </Container>
            </ModuleWrapper>
        );
    }
}

export default Numbers;

const ModuleWrapper = styled.section`
    margin: ${props => props.theme.spacing.elementM} 0;

    ${Media.greaterThan('s')`
        margin: ${props => props.theme.spacing.blockXS} 0;
    `}
`

const InnerGrid = styled.div`
    display: -ms-grid;
    display: grid;
    z-index: 10;
    overflow: hidden;
    -ms-grid-columns: 25px (1fr .359fr)[3] 1fr 25px;
    grid-template-columns: 25px repeat(3, 1fr .359fr) 1fr 25px;
    -ms-grid-rows: auto 1fr 1fr;
    grid-template-rows: auto 1fr 1fr;
    padding: ${props => props.theme.spacing.elementXS} 0;

    ${Media.greaterThan('xs')`
        padding: ${props => props.theme.spacing.blockS} 0 ${props => props.theme.spacing.blockXL};
    `}

    ${Media.greaterThan('s')`
        -ms-grid-columns: (1fr .67fr)[9] 1fr;
        grid-template-columns: repeat(9, 1fr .67fr) 1fr;
        -ms-grid-rows: 1fr 1fr;
        grid-template-rows: 1fr 1fr;
        padding: ${props => props.theme.spacing.blockL} 0;
    `}

    ${Media.greaterThan('m')`
        -ms-grid-columns: (1fr .435fr)[9] 1fr;
        grid-template-columns: repeat(9, 1fr .435fr) 1fr;
    `}

    h2 {
        font-size: 22px;
        line-height: 38px;
        margin-bottom: ${props => props.theme.spacing.contentXL};

        ${Media.greaterThan('xs')`
            margin-bottom: ${props => props.theme.spacing.elementS};
        `}

        ${Media.greaterThan('s')`
            font-size: 18px;
            line-height: 27px;
            text-align: center;
            margin-bottom: ${props => props.theme.spacing.blockM};
        `}

        ${Media.greaterThan('l')`
            font-size: 26px;
            line-height: 38px;
        `}
    }

    span {
        display: block;
        color: ${props => props.theme.colors.button};
        font-size: 80px;
        line-height: 95px;

        ${Media.greaterThan('xs')`
            font-size: 160px;
            line-height: 190px;
            padding-bottom: ${props => props.theme.spacing.contentL};
        `}

        ${Media.greaterThan('s')`
            padding-bottom: ${props => props.theme.spacing.contentM};
        `}

        ${Media.greaterThan('m')`
            font-size: 98px;
            line-height: 95px;
        `}

        ${Media.greaterThan('l')`
            font-size: 130px;
            line-height: 95px;
        `}

        ${Media.greaterThan('xl')`
            font-size: 162px;
            line-height: 95px;
        `}
    }

    p {
        font-size: 16px;

        ${Media.greaterThan('l')`
            font-size: 18px;
        `}
    }

    ${Media.lessThan('s')`
        p {
            &:nth-of-type(1),
            &:nth-of-type(2) {
                margin-bottom: ${props => props.theme.spacing.blockM};
            }
        }
    `}

    ${Media.lessThan('xs')`
        p {
            &:nth-of-type(1),
            &:nth-of-type(2) {
                margin-bottom: ${props => props.theme.spacing.elementXS};
            }
        }
    `}
`

const StyledGridElement = styled(GridElement)`
    padding-left: ${props => props.theme.spacing.contentS};
    opacity: 0;
    transition: .5s ease-in;
    transition-delay: .5s;
    
    ${props => props.visible && css`
        opacity: 1;
    `}

    ${Media.greaterThan('xs')`
        padding-left: 0;
    `}
`

const StyledLogo = styled(GreenLogo)`
    position: absolute;
    top: -100px;
    right: 0;
    bottom: 0;
    transform: translate(50%, -10%) scale(.8);
    z-index: -1;

    ${Media.greaterThan('xs')`
        transform: translate(50%, -18%) scale(1);
    `}

    ${Media.greaterThan('s')`
        transform: translate(40%, -10%);
    `}
`